import React, { useEffect, useState, useRef } from "react";
import { auth, db } from "../firebase-config";
import { signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Jukebox } from "./Jukebox";
import { AutoPlay } from "./AutoPlay";
import { Users } from "./Users";
import { ChatList } from "./ChatList";
import { HiddenChatList } from "./HiddenChatList";
import { LoadingAnimation } from "./LoadingAnimation";
import { Chat } from "./Chat";
import { SideBarMenu } from "./SideBarMenu";
import { Avatar } from "./Avatar";
import Cookies from "universal-cookie";
import { useIsVisible } from "../hooks/useIsVisible";
const cookies = new Cookies();
export const AppLayout = ({
  appMode,
  children,
  isAuth,
  setIsAuth,
  setIsInChat,
  setChatId,
  setIsLaunched,
  funcProp,
  client,
  appLayoutMode,
  pendingChatNavigation,
  setPendingChatNavigation,
}) => {
  const ref = useRef();
  const [isInChat2, setIsInChat2] = useState(null);
  const [isInUsers, setIsInUsers] = useState(null);
  const [isInJukebox, setIsInJukebox] = useState(null);
  const [isInAutoPlay, setIsInAutoPlay] = useState(null);
  const [isInHiddenChat, setIsInHiddenChat] = useState(null);
  const [isInChatList, setInChatList] = useState(true);
  const [chatId2, setChatId2] = useState(null);
  const [chatType, setChatType] = useState(null);
  const [trackDetails, setTrackDetails] = useState(null);
  const [isOpen, setIsopen] = useState(false); // sniff if view is desktop or mobile
  const [avatars, setAvatars] = useState({});
  const [userObject, setUserObject] = useState({});
  const [chatUsers, setChatUsers] = useState([]);
  const [showLoadingAni, setShowLoadingAni] = useState(false);
  const [clientObj, setClientObj] = useState(null);
  const [openJukeboxPlaylist, setOpenJukeboxPlaylist] = useState(false);
  // const [appMode, setAppMode] = useState(appMode)

  const [mode, setMode] = useState("light");
  
  // Handle pending chat navigation from toast clicks
  useEffect(() => {
    if (pendingChatNavigation && clientObj) {
      const { chatId, chatType, users } = pendingChatNavigation;
      // Use pickedChat to navigate to the chat
      pickedChat(chatId, chatType, null, users);
      // Clear the pending navigation
      setPendingChatNavigation(null);
    }
  }, [pendingChatNavigation, clientObj, setPendingChatNavigation]);
  
  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  const isLaunched = useIsVisible(ref);

  const signUserOut = async () => {
    //cookies.remove("auth-token");
    //cookies.remove("auth-token", {path: "/", domain: "muuzbox.com"})
    removeCookieWithPromise("auth-token", { path: "/" })
      .then(async () => {
        // console.log("Cookie removal complete. Now performing another task.");
        // Perform another task
        await signOut(auth);
        setIsAuth(false);
        setIsInChat(false);
        setIsInChat2(false);
        setIsInUsers(false);
      })
      .catch((error) => {
        console.error("Failed to remove cookie:", error);
      });
  };

  const removeCookieWithPromise = (cookieName, options = {}) => {
    return new Promise((resolve, reject) => {
      try {
        cookies.remove(cookieName, options); // Remove the cookie
        resolve(); // Resolve the promise
      } catch (error) {
        console.error("Error removing the cookie:", error);
        reject(error); // Reject the promise if there's an error
      }
    });
  };

  const closeAllPanels = () => {
    setShowLoadingAni(false);
    setIsInChat(false);
    setIsInChat2(false);
    setIsInUsers(false);
    setIsInJukebox(false);
    setIsInAutoPlay(false);
    setIsInHiddenChat(false);
    setIsopen(false);
  };
  const pickedChat = (chatId, type, trackDetails, users) => {
    closeAllPanels();
    setIsInChat2(true);
    setChatId(chatId);
    setChatId2(null);
    setChatId2(chatId);
    setChatType(type);
    setTrackDetails(trackDetails);
    setChatUsers(users);
  };
  const loadingAni = () => {
    closeAllPanels();
    setShowLoadingAni(true);
  };
  const openUsersPanel = () => {
    closeAllPanels();
    setIsInUsers(true);
  };
  const openJukeboxPanel = () => {
    closeAllPanels();
    if (window.location.hostname === "admin.muuzbox.com") {
      setIsInAutoPlay(true);
    } else {
      setIsInJukebox(true);
      setOpenJukeboxPlaylist(!openJukeboxPlaylist);
    }
  };
  const openAutoPlayPanel = () => {
    closeAllPanels();
    setIsInAutoPlay(true);
  };
  const openHiddenChatPanel = () => {
    closeAllPanels();
    setShowLoadingAni(false);
    setIsInHiddenChat(true);
  };
  const refreshChatList = () => {
    // setInChatList(false);
    // setTimeout(() => {
    //   setInChatList(true);
    // }, 300);
  };
  const sbm = (message) => {
    if (message === "sign out") signUserOut();
  };

  useEffect(() => {
    // console.log("appMode", appMode);
  }, [appMode]);

  useEffect(() => {
    // Add listener to update styles
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) =>
        onSelectMode(e.matches ? "dark" : "light")
      );

    // Setup dark/light mode for the first time
    onSelectMode(
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
    );

    // find the client uid
    const getClientObj = async () => {
      if (client) {
        const docRef = doc(db, "clients", client);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const Obj = {
            id: docSnap.id,
            clientId: docSnap.data().clientId,
            defaultPlaylist: docSnap.data().defaultPlaylist,
            avatarImage: docSnap.data().avatarImage,
            nowPlayingCompactLayout:
              docSnap.data().nowPlayingCompactLayout === true,
          };
          setClientObj(Obj);
        }
      }
    };
    getClientObj();

    // Remove listener
    return () => {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", () => {});
    };
  }, []);

  React.useEffect(() => {
    if (isLaunched) {
      //callbackFn(); // Trigger a function when the div is visible on view port
      setIsLaunched(true);
    }
  }, [isLaunched]);

  const onSelectMode = (mode) => {
    setMode(mode);
    if (mode === "dark") {
      // document.body.classList.add('dark-mode')
      document.documentElement.setAttribute("data-theme", "dark");
      // console.log("dark mode");
    } else {
      // document.body.classList.remove('dark-mode')
      document.documentElement.setAttribute("data-theme", "light");
      // console.log("light mode");
    }
  };

  useEffect(() => {
    if (isAuth !== undefined || isAuth !== false) {
      setTimeout(async () => {
        // actually go get the user detail from the user collection rather than from the auth
        // when anonymous reloads it loses its displayName and photo.
        const avObj = {};
        try {
          await getUserDetails(auth?.currentUser?.uid).then((userObj) => {
            avObj[auth?.currentUser?.uid] = userObj;
            setUserObject(userObj);
            setAvatars(avObj);
          });
        } catch (err) {
          console.log("error", err);
        }
      }, 3000);
    }
  }, [isAuth]);

  const getUserDetails = async (uid) => {
    const docRef = doc(db, "users", uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return {
        displayName: docSnap.data().displayName,
        photoURL: docSnap.data().photoURL,
        email: docSnap.data().email,
        nameChanged: docSnap.data().nameChanged || false,
        id: docSnap.id,
        bio: docSnap.data().bio,
      };
    }
  };

  if (!auth.currentUser) {
    <div>LOADING...</div>;
  }

  const UserName = () => {
    <div className="text-xs text-white">{auth?.currentUser?.displayName}</div>;
  };

  return (
    <div ref={ref} className="App bg-white dark:bg-black">
      <div className="flex flex-row justify-between max-w-full manuf-header"> {/* HEADER */}
        <SideBarMenu
          userObj={userObject}
          openUsersPanel={openUsersPanel}
          openJukeboxPanel={openJukeboxPanel}
          openAutoPlayPanel={openAutoPlayPanel}
          openHiddenChatPanel={openHiddenChatPanel}
          sbm={sbm}
          funcProp={funcProp}
          loadingAni={loadingAni}
          appMode={appMode}
          appLayoutMode={appLayoutMode}
        />
        <div className="flex flex-row items-center">
          <div
            onClick={() => {
              appLayoutMode("newlayout");
            }}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 9V18C4 19.1046 4.89543 20 6 20H9M4 9V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V9M4 9H9M20 9H9M20 9V14.5M9 9V14.5M9 20H18C19.1046 20 20 19.1046 20 18V14.5M9 20V14.5M9 14.5H20"
                stroke="#FFFFFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            onClick={() => {
              appLayoutMode("newlayout");
            }}
          >
            
            {/* <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 9V18C4 19.1046 4.89543 20 6 20H10M4 9V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V9M4 9H10M20 9V18C20 19.1046 19.1046 20 18 20H10M20 9H10M10 9V20"
                stroke="#FFFFFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg> */}
          </div>
        </div>
        <div class="flex flex-row items-center muuzbox-title">
            {/* <div className="muuzbox-wc-logo mr-2"></div> */}
            {/* <div className="text-4xl" style={{fontWeight: "500", fontSize: "25px"}}>MUUZBOX</div> */}
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 2107.01 561.16"
              width="150px"
              height="40px"
            >
              <defs>
                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n                .cls-1 {\n                  fill: #fa163f;\n                }\n\n                .cls-2 {\n                  fill: #fff;\n                }\n\n                .cls-3 {\n                  fill: #2e6db5;\n                }\n              ",
                  }}
                />
              </defs>
              <path
                class="cls-1"
                d="m25.39,414l216.88,125.23V21.28L25.39,146.51v267.49Zm29.92-244.97l154.81-88.67v399.03l-28.42-16.29V129.14l-33.99,19.61v294.83l-28.5-16.29V164.96l-35.4,20.36v220.54h-1.5l-27.01-15.12v-221.7Z"
              />
              <polygon
                class="cls-3"
                points="333.52 278.8 333.52 278.72 333.19 278.72 333.19 429.13 431.08 372.95 431.08 290.6 397.42 278.8 333.52 278.8"
              />
              <path
                class="cls-3"
                d="m272.53,539.56l216.88-125.23V146.51L272.53,21.28v518.28Zm32.57-459.2l154.4,88.67v80.94l-24.02,12.22,24.02,8.48v118.91l-154.4,89.08V80.36Z"
              />
              <polygon
                class="cls-3"
                points="333.52 250.3 396.67 250.3 431.41 232.6 431.41 185.32 333.52 129.14 333.52 250.3"
              />
              <path
                class="cls-2"
                d="m459.5,270.66l-24.02-8.48,24.02-12.22v-80.94l-154.4-88.67v398.29l154.4-89.08v-118.91Zm-28.42,102.29l-97.89,56.17v-150.41h.33v.08h63.9l33.65,11.8v82.35Zm.33-140.35l-34.73,17.7h-63.15v-121.16l97.89,56.17v47.28Z"
              />
              <polygon
                class="cls-2"
                points="83.81 405.86 83.81 185.32 119.21 164.96 119.21 427.3 147.71 443.58 147.71 148.75 181.7 129.14 181.7 463.11 210.12 479.4 210.12 80.36 55.31 169.03 55.31 390.73 82.32 405.86 83.81 405.86"
              />
              <g>
                <path
                  class="cls-2"
                  d="m836.31,459.83h-49.8v-247.2l-51.6,247.2h-24l-54.2-247.2v247.2h-49.8V102.33h72l44,217.9,40.9-217.9h72.5v357.5h0Z"
                />
                <path
                  class="cls-2"
                  d="m998.61,102.33h53.8v241c0,33.3-2.2,56.5-7.1,69.4-7.1,19.1-19.6,33.3-36,42.2-12,6.7-25.8,9.8-40.5,9.8-26.7,0-47.6-9.3-62.7-28.5-10.2-12.9-16.5-26.7-18.7-41.8-1.8-13.8-2.7-31.1-2.7-51.6V101.83h53.8v235.2c0,31.1,1.3,50.2,3.6,56.9,4.4,13.3,13.3,20,26.7,20s23.6-8,27.6-23.6c1.8-6.7,2.7-24.5,2.7-53.8V101.33l-.4.9h-.1v.1Z"
                />
                <path
                  class="cls-2"
                  d="m1214.61,102.33h53.8v241c0,33.3-2.2,56.5-7.1,69.4-7.1,19.1-19.6,33.3-36,42.2-12,6.7-25.8,9.8-40.5,9.8-26.7,0-47.6-9.3-62.7-28.5-10.2-12.9-16.5-26.7-18.7-41.8-1.8-13.8-2.7-31.1-2.7-51.6V101.83h53.8v235.2c0,31.1,1.3,50.2,3.6,56.9,4.4,13.3,13.3,20,26.7,20s23.6-8,27.6-23.6c1.8-6.7,2.7-24.5,2.7-53.8V101.33l-.4.9h-.1v.1Z"
                />
                <path
                  class="cls-2"
                  d="m1467.21,409.53v49.8h-160.1v-49.8l103.6-257.4h-95.6v-49.8h152.5v49.8l-102.7,257.4h102.7-.4Z"
                />
                <path
                  class="cls-2"
                  d="m1505.01,459.83V102.33h74.3c24.5,0,43.1,4.9,56.9,15.1,21.3,15.6,32,41.3,32,77.4s-4.4,40.9-13.8,55.6c-5.3,8.9-13.3,16.9-24,24.5,11.6,6.2,20.5,12.9,25.8,20.9,11.6,16.5,17.3,39.1,17.3,68s-8.9,61.8-26.2,78.3c-8.9,8.4-19.1,13.8-30.7,15.6-8.9,1.8-20,2.2-33.3,2.2h-79.1.9-.1v-.1Zm53.8-209.9h11.1c14.7,0,25.3-3.1,31.6-8.9,9.8-8.9,14.7-24,14.7-44,0-29.8-12.4-44.5-37.3-44.5h-20v97.8-.4h-.1Zm0,159.6h20c14.2,0,24.5-3.6,30.7-10.2,8-8.4,11.6-22.2,11.6-41.8s-5.8-40.5-16.9-49.8c-6.2-5.3-16.9-8-32-8h-13.3v109.8h-.1Z"
                />
                <path
                  class="cls-2"
                  d="m1886.91,218.83v124.5c0,33.3-2.2,56.5-7.1,69.4-7.1,19.1-19.6,33.3-36,42.2-12,6.7-25.8,9.8-40.5,9.8-26.7,0-47.6-9.3-62.7-28.5-10.2-12.9-16.5-26.7-18.7-41.8-1.8-13.8-2.7-31.1-2.7-51.6v-124.5c0-33.3,2.2-56.9,7.1-69.8,7.1-18.7,19.6-32.9,36-42.2,12-6.7,25.8-9.8,40.5-9.8,26.7,0,47.6,9.3,62.7,28.5,10.2,12.9,16.5,26.7,18.2,41.8,1.8,13.8,2.7,31.1,2.7,51.6l.4.4h.1Zm-114.3,5.3v113.4c0,31.1,1.3,50.2,3.6,56.9,4.4,13.3,13.3,20,26.7,20s23.6-8,27.6-23.6c1.8-6.7,2.7-24.5,2.7-53.8v-113.4c0-31.1-1.3-50.2-3.6-56.9-4.9-13.3-13.8-20-27.1-20s-23.6,8-27.6,23.6c-1.8,6.7-2.7,24.9-2.7,53.8h.4Z"
                />
                <path
                  class="cls-2"
                  d="m2037.21,276.23l69.8,183.6h-56.5l-42.2-115.2-39.1,115.2h-55.6l67.1-183.6-64.5-173.8h56.5l37.3,105.4,34.7-105.4h55.6l-62.7,173.8h-.4Z"
                />
              </g>
            </svg>
            {/* <span>v 0.5.6</span> */}
          </div>
        {/* <div class="close-muuzbox-btn ion-close"></div> */}
      </div>
      <div className="app-container max-w-full">
        {children}
        {isAuth && (
          <>
            <section className="h-screen overflow-hidden flex items-center justify-center max-w-full">
              <div className="flex h-screen antialiased text-gray-800 dark:text-white w-full">
                <div className="flex flex-row h-full w-full overflow-hidden">
                  <div
                    className={`flex flex-col py-8 pr-2 w-7 md:w-40 flex-shrink-0 sidebar ${
                      isOpen === true ? "active" : ""
                    }`}
                    style={{ height: "calc(100dvh - 162px)" }}
                  >
                    <div className="flex flex-col md:flex-row items-center justify-center h-12 w-full my-2">
                      <div className="flex flex-row justify-center">
                        <div
                          onClick={openJukeboxPanel}
                          className="muuzbox-wc-logo"
                        ></div>
                      </div>
                    </div>
                    <UserName />
                    <div className="flex flex-col flex-auto items-center justify-between bg-indigo-100 mt-4  w-full py-6 px-6 rounded-lg mobile-chatlist panel-fade relative">
                      <div>
                        {/* <SideBarMenu
                          openUsersPanel={openUsersPanel}
                          openJukeboxPanel={openJukeboxPanel}
                          openAutoPlayPanel={openAutoPlayPanel}
                          openHiddenChatPanel={openHiddenChatPanel}
                          sbm={sbm}
                          funcProp={funcProp}
                          loadingAni={loadingAni}
                          appMode={appMode}
                          appLayoutMode={appLayoutMode}
                        /> */}
                        <div className="flex justify-center h-16 w-16 md:h-20 md:w-20 rounded-full border overflow-hidden text-center items-center hidden">
                          {isAuth !== undefined && (
                            <Avatar
                              avObj={avatars}
                              uid={auth?.currentUser?.uid}
                            />
                          )}
                        </div>
                        <div class="text-center items-center text-xs font-black rac-padding text-white">
                          Requests &amp; Chat
                        </div>
                        <div
                          className={`flex flex-col space-y-1 mt-4 -mx-2 ebuebu wc-chatlist  ${
                            isOpen === true ? "hidden" : ""
                          }`}
                        >
                          {isInChatList && clientObj && (
                            <ChatList
                              pickedChat={pickedChat}
                              thinLayout={true}
                              loadingAni={loadingAni}
                              clientObj={clientObj}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {isInChat2 && clientObj && window.location.hostname !== "admin.muuzbox.com"  (
                    <Chat
                      newchatId={chatId2}
                      chatId={chatId2}
                      chatType={chatType}
                      trackDetails={trackDetails}
                      openJukeboxPanel={openJukeboxPanel}
                      userObj={userObject}
                      chatUsers={chatUsers}
                      refreshChatList={refreshChatList}
                      clientObj={clientObj}
                    />
                  )}
                  {isInUsers && <Users refreshChatList={refreshChatList} />}
                  {isInJukebox && clientObj && (
                    <Jukebox
                      userObj={userObject}
                      clientObj={clientObj}
                      openJukeboxPlaylist={openJukeboxPlaylist}
                    />
                  )}
                  {isInAutoPlay && <AutoPlay userObj={userObject} />}
                  {isInHiddenChat && (
                    <HiddenChatList
                      pickedChat={pickedChat}
                      thinLayout={false}
                      loadingAni={loadingAni}
                    />
                  )}
                  {/* showLoadingAni */}
                  {showLoadingAni && <LoadingAnimation />}
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};
